import img1 from "../../assets/png/m2-img1.png";
import img2 from "../../assets/png/m2-img4.png";
import img3 from "../../assets/png/m4-img1.png";
import img4 from "../../assets/png/m4-img2.png";
import img5 from "../../assets/png/m1-img1.png";

import { useTranslate } from "../../hooks/useTranslate";
import {
  TitleArtical,
  AboutArticle,
  ImagePublished,
  ManyImagesPublished,
} from "./styles";

const M4 = () => {
  const { translate } = useTranslate();

  return (
    <>
      <TitleArtical>{translate("content_center.title_matter_4")}</TitleArtical>
      <AboutArticle>
        <p>{translate("content_center.paragraph_2_matter_4")}</p>
        <ImagePublished>
          <img
            src={img1}
            alt={translate("content_center.paragraph_2_matter_4")}
          />
        </ImagePublished>
        <p>{translate("content_center.paragraph_3_matter_4")}</p>
        <ManyImagesPublished>
          <img
            src={img2}
            alt={translate("content_center.paragraph_3_matter_4")}
          />
          <img
            src={img3}
            alt={translate("content_center.paragraph_3_matter_4")}
          />
          <img
            src={img4}
            alt={translate("content_center.paragraph_3_matter_4")}
          />
          <img
            src={img5}
            alt={translate("content_center.paragraph_3_matter_4")}
          />
        </ManyImagesPublished>
        <p>{translate("content_center.paragraph_3_matter_4")}</p>
        <p>{translate("content_center.paragraph_4_matter_4")}</p>
      </AboutArticle>
    </>
  );
};

export { M4 };
